import React from 'react';
import { Shield } from 'lucide-react';
import { getAdminPageSubtitle } from '../adminConsoleCopy';

interface AdminConsoleContextBarProps {
  pathname: string;
}

/** Faixa de contexto — deixa claro que é a cabine do SaaS, não a fábrica do cliente. */
export const AdminConsoleContextBar: React.FC<AdminConsoleContextBarProps> = ({ pathname }) => (
  <div className="shrink-0 border-b border-[var(--border-default)]/60 bg-[var(--bg-elevated)]/50 px-[var(--shell-content-inset,12px)] py-2">
    <div className="flex items-center gap-2 text-[11px] text-[var(--text-secondary)]">
      <Shield size={12} className="shrink-0 opacity-70" />
      <span>{getAdminPageSubtitle(pathname)}</span>
    </div>
  </div>
);
